import { useQuery } from "@tanstack/react-query";
import { ConfigurationDetails, TenantOptionsDetails } from "features/types";
import { get } from "services/http";

export const useFetchTenantConfigurationQuery = () => {
  return useQuery(
    ["fetchTenantConfiguration"],
    async () => {
      const tenantOptions = await get<TenantOptionsDetails>({
        url: `/configuration/tenant`,
      });
      return tenantOptions;
    },
    {
      staleTime: Infinity,
    }
  );
};

export const useFetchConfigurationQuery = () => {
  return useQuery(
    ["fetchConfiguration"],
    () => {
      return get({
        url: `/configuration`,
      }) as Promise<ConfigurationDetails>;
    },
    {
      staleTime: Infinity,
      enabled: false,
    }
  );
};
